import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

/**
 * Price — Page /coming-soon
 * Landing pre-launch : compteur J-X + waitlist email + lien Instagram.
 * ⚠️ Le formulaire email est MOCKED (log console) — brancher un service
 *    Mailchimp/Resend plus tard quand le backend waitlist sera prêt.
 */

const LAUNCH_DATE = new Date("2026-08-20T09:00:00+02:00");

export default function PriceComingSoon() {
  const [now, setNow] = useState(Date.now());
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState("idle"); // idle | loading | ok | err

  useEffect(() => {
    document.title = "Price arrive bientôt · Price Covoiturage";
    const t = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(t);
  }, []);

  const diff = Math.max(0, LAUNCH_DATE.getTime() - now);
  const d = Math.floor(diff / (1000 * 60 * 60 * 24));
  const h = Math.floor((diff / (1000 * 60 * 60)) % 24);
  const m = Math.floor((diff / (1000 * 60)) % 60);
  const s = Math.floor((diff / 1000) % 60);
  const timeBlocks = [
    { label: "Jours", value: d },
    { label: "Heures", value: h },
    { label: "Minutes", value: m },
    { label: "Secondes", value: s },
  ];

  async function onSubmit(e) {
    e.preventDefault();
    if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      setStatus("err");
      return;
    }
    setStatus("loading");
    try {
      await new Promise((r) => setTimeout(r, 500));
      // MOCKED — pas de backend waitlist. On log pour que l'user ait
      // au moins une trace en console pendant la phase de pré-lancement.
      console.log("[price][waitlist] new signup:", email);
      setStatus("ok");
      setEmail("");
    } catch {
      setStatus("err");
    }
  }

  return (
    <main className="relative min-h-screen overflow-hidden" style={{ background: "#FFF6EE" }}>
      <div
        className="absolute inset-0 opacity-40 pointer-events-none"
        style={{
          backgroundImage:
            "linear-gradient(rgba(30,9,16,0.06) 1px, transparent 1px), linear-gradient(90deg, rgba(30,9,16,0.06) 1px, transparent 1px)",
          backgroundSize: "32px 32px",
        }}
        aria-hidden
      />
      <div className="pointer-events-none absolute -top-40 -left-20 h-96 w-96 rounded-full blur-3xl" style={{ background: "rgba(248,106,120,0.25)" }} aria-hidden />
      <div className="pointer-events-none absolute -bottom-40 -right-20 h-96 w-96 rounded-full blur-3xl" style={{ background: "rgba(184,232,211,0.40)" }} aria-hidden />

      <div className="relative mx-auto flex min-h-screen max-w-3xl flex-col items-center justify-center px-5 py-16 text-center">
        <div className="inline-flex items-center gap-2 rounded-full bg-white px-4 py-2 text-[11px] font-black uppercase tracking-widest street-border-thin" style={{ color: "#1E0910", boxShadow: "3px 3px 0 0 #1E0910" }}>
          <span className="h-2 w-2 rounded-full animate-ping-slow" style={{ background: "#F86A78" }} />
          Bientôt en ligne
        </div>

        <h1 className="mt-8 font-[Outfit] font-black tracking-tight text-[52px] leading-[0.9] sm:text-[80px] lg:text-[110px]" style={{ color: "#1E0910" }}>
          Price arrive{" "}
          <span className="relative inline-block whitespace-nowrap">
            <span className="relative z-10" style={{ color: "#F86A78" }}>bientôt</span>
            <span className="absolute inset-x-0 bottom-2 -z-0 h-5 rotate-[-1.5deg]" style={{ background: "rgba(248,106,120,0.25)" }} aria-hidden />
          </span>
          .
        </h1>

        <p className="mt-6 max-w-lg font-[Manrope] text-lg" style={{ color: "rgba(30,9,16,0.7)" }}>
          Le covoiturage instantané du quotidien. On peaufine les derniers détails —
          laisse ton email pour être prévenu dès l&apos;ouverture.
        </p>

        {/* Countdown */}
        <div className="mt-10 grid grid-cols-4 gap-3 md:gap-5" role="timer" aria-live="polite" data-testid="countdown">
          {timeBlocks.map((b) => (
            <div key={b.label} className="rounded-2xl bg-white px-3 py-4 street-border-thin md:px-5 md:py-6" style={{ boxShadow: "3px 3px 0 0 #1E0910" }}>
              <div className="font-[Outfit] text-3xl font-black leading-none md:text-5xl">{String(b.value).padStart(2, "0")}</div>
              <div className="mt-2 text-[9px] font-black uppercase tracking-widest md:text-xs" style={{ color: "rgba(30,9,16,0.6)" }}>{b.label}</div>
            </div>
          ))}
        </div>

        {/* Email form */}
        <form onSubmit={onSubmit} className="mt-10 w-full max-w-md">
          <div className="flex flex-col gap-3 sm:flex-row">
            <input
              type="email"
              required
              value={email}
              onChange={(e) => { setEmail(e.target.value); setStatus("idle"); }}
              placeholder="ton@email.fr"
              data-testid="waitlist-email"
              aria-label="Adresse email"
              className="flex-1 rounded-full bg-white px-5 py-3.5 text-sm font-semibold street-border-thin outline-none focus:!border-[#F86A78]"
              style={{ color: "#1E0910" }}
            />
            <button
              type="submit"
              disabled={status === "loading"}
              data-testid="waitlist-submit"
              className="street-press inline-flex items-center justify-center gap-2 rounded-full px-6 py-3.5 text-sm font-black uppercase tracking-widest text-white street-border disabled:opacity-70"
              style={{ background: "#F86A78", boxShadow: "5px 5px 0 0 #1E0910" }}
            >
              {status === "loading" ? "Envoi…" : "Me prévenir"}
            </button>
          </div>
          <div className="mt-3 min-h-[20px] text-xs">
            {status === "ok" && <div className="font-black" style={{ color: "#F86A78" }} data-testid="waitlist-ok">✓ Bien reçu — on te tient au courant.</div>}
            {status === "err" && <div className="font-semibold" style={{ color: "rgba(248,106,120,0.85)" }}>Merci d&apos;entrer un email valide.</div>}
          </div>
        </form>

        <div className="mt-10 flex items-center gap-3">
          <div className="text-xs font-black uppercase tracking-widest" style={{ color: "rgba(30,9,16,0.6)" }}>Suis-nous</div>
          <a
            href="https://www.instagram.com/pricecovoit"
            target="_blank"
            rel="noopener noreferrer"
            className="street-press inline-flex items-center gap-2 rounded-full bg-white px-4 py-2 text-sm font-bold street-border-thin transition-colors hover:!bg-[#F86A78] hover:!text-white"
            style={{ boxShadow: "3px 3px 0 0 #1E0910" }}
          >
            <svg viewBox="0 0 24 24" className="h-4 w-4" fill="currentColor" aria-hidden>
              <path d="M12 2.2c3.2 0 3.6 0 4.8.1 1.2.1 1.9.2 2.4.4.6.2 1 .5 1.5 1s.8.9 1 1.5c.2.5.3 1.2.4 2.4.1 1.2.1 1.6.1 4.8s0 3.6-.1 4.8c-.1 1.2-.2 1.9-.4 2.4a4 4 0 0 1-1 1.5c-.5.5-.9.8-1.5 1-.5.2-1.2.3-2.4.4-1.2.1-1.6.1-4.8.1s-3.6 0-4.8-.1c-1.2-.1-1.9-.2-2.4-.4a4 4 0 0 1-1.5-1 4 4 0 0 1-1-1.5c-.2-.5-.3-1.2-.4-2.4C2.2 15.6 2.2 15.2 2.2 12s0-3.6.1-4.8c.1-1.2.2-1.9.4-2.4.2-.6.5-1 1-1.5s.9-.8 1.5-1c.5-.2 1.2-.3 2.4-.4C8.4 2.2 8.8 2.2 12 2.2Zm0 8.8a5 5 0 1 0 0 10 5 5 0 0 0 0-10Zm0 8.2a3.2 3.2 0 1 1 0-6.4 3.2 3.2 0 0 1 0 6.4Zm5.2-8.4a1.2 1.2 0 1 0 0-2.4 1.2 1.2 0 0 0 0 2.4Z" />
            </svg>
            @pricecovoit
          </a>
        </div>

        <div className="mt-10">
          <Link to="/" className="text-xs font-bold underline decoration-2 underline-offset-4 transition-colors hover:!text-[#F86A78]" style={{ color: "rgba(30,9,16,0.5)" }}>
            Aller sur le site
          </Link>
        </div>
      </div>
    </main>
  );
}
